module.exports = __webpack_public_path__ + "img/2023big15.17acfc7c.png";